export class booleanHelper
{
	static toBoolean(value)
	{
		//if (value===null || value===undefined) return false;
		var strValue=value.toString().toLowerCase();
		return (
				strValue==="1"
			||  strValue==="true"
		);
	}

	static isAllTrue(array)
	{
		return (array.find(a=>a===false)===undefined)
	}

	static Or(...values)
	{
		let res=false;
		values.forEach(v=>res=res|| booleanHelper.toBoolean(v) );
		return res;
	}

	
}

export default booleanHelper;